<template>
  <FormulateInput
    type="checkbox"
    :label="label"
    v-model="input_value"
    label-position="before"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: "InputBoolean",
  props: ["label", "value", "options", "name", "disabled"],
  data() {
    return {
      input_value: this.value
    };
  },
  watch: {
    input_value(value) {
      this.$emit("FlexpropDataChange", { key: this.name, value: value });
    }
  }
};
</script>
